import { render } from "./AddPlayer.vue?vue&type=template&id=55fc297d&scoped=true"
import script from "./AddPlayer.vue?vue&type=script&lang=js"
export * from "./AddPlayer.vue?vue&type=script&lang=js"

import "./AddPlayer.vue?vue&type=style&index=0&id=55fc297d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fc297d"]])

export default __exports__